import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URLS } from '../../../shared/constants/api-request.urls';

@Injectable({ providedIn: 'root' })
export class SplitsService {
  private http = inject(HttpClient);

  getSplits(stockId?: string, pageNumber?: number, pageSize?: number): Observable<any> {
    let params = new HttpParams();
    if (stockId) params = params.set('stockId', stockId);
    if (pageNumber) params = params.set('pageNumber', pageNumber);
    if (pageSize) params = params.set('pageSize', pageSize);

    return this.http.get(URLS.SPLIT, { params });
  }

  getSplitById(id: string): Observable<any> {
    return this.http.get(`${URLS.SPLIT}/${id}`);
  }

  createSplit(split: any): Observable<any> {
    console.log('Creating split:', split);
    return this.http.post(URLS.SPLIT, split);
  }

  updateSplit(id: string, split: any): Observable<any> {
    return this.http.put(`${URLS.SPLIT}/${id}`, split);
  }

  deleteSplit(id: string): Observable<any> {
    return this.http.delete(`${URLS.SPLIT}/${id}`);
  }
}
